import React from 'react';

interface HeatLogoProps {
  className?: string;
  variant?: 'full' | 'icon'; // Used to toggle between full logo and icon only
}

export default function HeatLogo({ className = "h-8 w-auto", variant = 'icon' }: HeatLogoProps) {
  if (variant === 'full') {
    return (
      <svg
        className={className}
        viewBox="0 0 200 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Background flame shape */}
        <path
          d="M15 45C15 45 5 35 5 25C5 15 15 5 25 5C35 5 45 15 45 25C45 30 42 34 38 37C40 40 45 42 50 42C60 42 65 35 65 25C65 10 55 0 40 0C25 0 10 10 10 25C10 35 15 45 15 45Z"
          fill="url(#flameGradient)"
        />
        
        {/* Inner flame */}
        <path
          d="M25 35C25 35 20 30 20 25C20 20 25 15 30 15C35 15 40 20 40 25C40 27 39 29 37 30C38 31 40 32 42 32C47 32 50 28 50 25C50 17 45 10 37 10C29 10 22 17 22 25C22 30 25 35 25 35Z"
          fill="url(#innerFlameGradient)"
        />
        
        {/* Heat.Coach Text */}
        <text
          x="75"
          y="35"
          fontFamily="Inter, sans-serif"
          fontSize="24"
          fontWeight="bold"
          fill="#1f2937"
        >
          Heat.Coach
        </text>

        {/* Subtitle */}
        <text
          x="75"
          y="50"
          fontFamily="Inter, sans-serif"
          fontSize="8"
          fill="#6b7280"
        >
          HEALTHY EXTREME ATHLETICS TRAINING AI COACH
        </text>
        
        <defs>
          <linearGradient id="flameGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#ef4444" />
            <stop offset="50%" stopColor="#f97316" />
            <stop offset="100%" stopColor="#eab308" />
          </linearGradient>
          <linearGradient id="innerFlameGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#fbbf24" />
            <stop offset="100%" stopColor="#f59e0b" />
          </linearGradient>
        </defs>
      </svg>
    );
  }

  // Icon variant - just the flame
  return (
    <svg
      className={className}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Main flame shape */}
      <path
        d="M25 45C25 45 10 35 10 22C10 12 18 2 28 2C38 2 46 12 46 22C46 28 42 33 37 36C40 39 46 41 50 41C60 41 65 34 65 22C65 7 55 -3 40 -3C25 -3 10 7 10 22C10 35 25 45 25 45Z"
        fill="url(#flameGradient)"
        transform="scale(0.8) translate(5, 5)"
      />
      
      {/* Inner flame */}
      <path
        d="M28 35C28 35 18 28 18 22C18 16 23 10 30 10C37 10 42 16 42 22C42 25 40 27 37 29C39 30 42 31 45 31C50 31 53 27 53 22C53 14 48 7 40 7C32 7 25 14 25 22C25 28 28 35 28 35Z"
        fill="url(#innerFlameGradient)"
        transform="scale(0.8) translate(5, 5)"
      />
      
      <defs>
        <linearGradient id="flameGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#ef4444" />
          <stop offset="50%" stopColor="#f97316" />
          <stop offset="100%" stopColor="#eab308" />
        </linearGradient>
        <linearGradient id="innerFlameGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#fbbf24" />
          <stop offset="100%" stopColor="#f59e0b" />
        </linearGradient>
      </defs>
    </svg>
  );
}
